<div class="search-wrapper">
  <p-auto-complete
    id="search-input"
    [(ngModel)]="selectedClient"
    [suggestions]="filteredClients"
    (completeMethod)="filterClients($event)"
    [emptyMessage]="'Keine Ergebnisse gefunden.'"
    [autofocus]="true"
    [autoHighlight]="true"
    (onSelect)="onSelectClient($event)"
    [dropdown]="true"
    dropdownIcon="pi pi-search"
    fluid
    optionLabel="name"
    placeholder="Patient suchen (Name, SV-Nr.)"
    styleClass="w-100"
    inputStyleClass="search-wrapper-input"
    panelStyleClass="p-0"
    data-cy="sana-tp-client-search-input">

    <ng-template
        let-client
        #item>

      <div
        class="client-entry"
        data-cy="sana-tp-client-search-entry">

        <i class="pi pi-user"></i>

        <div class="client-details">
          <div class="client-name">{{ client.fullName }}</div>
          <div class="client-therapy-plans">{{ client.socialSecurityNumber }} / {{ client.dateOfBirth | date:'dd.MM.yyyy' }}</div>
        </div>
      </div>
    </ng-template>

    <ng-template #footer>
      <div
        class="add-new-btn"
        data-cy="sana-tp-client-addNewClient"
        (click)="routeToNewClient()">

        <span class="add-new-client">
          <i class="pi pi-plus-circle"></i>
          Neuen Patienten anlegen
        </span>
      </div>
    </ng-template>
  </p-auto-complete>
</div>
